import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { fmtErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useCaptcha, CaptchaField } from "../components/Captcha";
import { toast } from "sonner";
import { LifeBuoy } from "lucide-react";

const inputCls = "mt-1 w-full bg-white border border-neutral-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-neutral-900 outline-none";

export default function HelpdeskSignup() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { captcha, answer, setAnswer, refresh, payload } = useCaptcha();
  const [form, setForm] = useState({ company_name: "", name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/helpdesk/signup", { ...form, ...payload, website: "" });
      setUser(data);
      toast.success("Workspace created — welcome to GloriDesk!");
      navigate("/desk");
    } catch (err) { toast.error(fmtErr(err)); refresh(); setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F1F4F8] flex items-center justify-center px-4 py-10">
      <div className="max-w-md w-full">
        <Link to="/helpdesk" className="flex items-center justify-center gap-2 font-bold text-xl font-heading mb-6"><LifeBuoy size={24} className="text-sky-500" /> GloriDesk</Link>
        <form onSubmit={submit} className="bg-white border border-neutral-200 rounded-2xl shadow-sm p-7" data-testid="helpdesk-signup-form">
          <h1 className="text-xl font-bold font-heading">Create your helpdesk workspace</h1>
          <p className="text-sm text-neutral-500 mt-1 mb-5">Free 14-day trial — no card required.</p>
          <label className="text-sm font-medium text-neutral-700">Company name</label>
          <input data-testid="hd-company-input" required minLength={2} value={form.company_name} onChange={set("company_name")} className={inputCls} />
          <label className="text-sm font-medium text-neutral-700 mt-3 block">Your name</label>
          <input data-testid="hd-name-input" required value={form.name} onChange={set("name")} className={inputCls} />
          <label className="text-sm font-medium text-neutral-700 mt-3 block">Work email</label>
          <input data-testid="hd-email-input" type="email" required value={form.email} onChange={set("email")} className={inputCls} />
          <label className="text-sm font-medium text-neutral-700 mt-3 block">Password (min 8)</label>
          <input data-testid="hd-password-input" type="password" required minLength={8} value={form.password} onChange={set("password")} className={inputCls} />
          <div className="mt-3"><CaptchaField captcha={captcha} answer={answer} setAnswer={setAnswer} refresh={refresh} testId="hd-captcha" /></div>
          <button data-testid="hd-signup-button" disabled={busy}
            className="mt-5 w-full py-2.5 rounded-md text-white bg-neutral-900 hover:bg-neutral-800 text-sm font-medium disabled:opacity-50">
            {busy ? "Creating workspace..." : "Create workspace"}
          </button>
          <p className="text-xs text-neutral-400 mt-4 text-center">Already have an account? <Link to="/login" className="underline">Log in</Link></p>
        </form>
      </div>
    </div>
  );
}
